<div class="basin-display-flex basin-flex-column basin-gap-4 basin-align-items-center basin-justify-content-center">
  <basin-circled-icon icon="symbol-warning" size="large" theme="inverse-blue"></basin-circled-icon>
  <div class="basin-display-flex basin-flex-column basin-gap-1 basin-align-items-center basin-justify-content-center">
    <p
      class="basin-font-secondary basin-font-size-20 basin-font-weight-bold basin-color-darkest-gray basin-line-height-24">
      Warning!</p>
    <p class="basin-font-primary basin-font-size-12 basin-color-dark-gray basin-line-height-18">
      {{ subheaderText }}
    </p>
  </div>


  <p
    class="basin-font-primary basin-font-size-14 basin-line-height-20 basin-color-primary-black basin-text-align-center">
    The system will not show real-time visualization {{ issueText }}.
  </p>
  <p
    class="basin-font-primary basin-font-size-14 basin-line-height-20 basin-color-primary-black basin-text-align-center">
    Once the simulation is complete, a confirmation email will be sent to you with a link to access the files.
  </p>
  <div class="basin-pb-4 basin-width-100">
    <form [formGroup]="form" class="basin-position-relative basin-simulation-name-form">
      <formly-form (keydown)="onKeyDown($event)" [form]="form" [fields]="fields" [model]="model">
      </formly-form>
      <p
        class="basin-font-primary basin-font-size-12 basin-color-light-gray basin-line-height-12 basin-position-absolute helper-text basin-left-0">
        {{ simulationNameHelperText }}
      </p>
    </form>
  </div>
  <div class="basin-display-flex basin-flex-row basin-gap-3">
    <button pButton styleClass="p-button-outlined" label="Cancel" (click)="cancel()">
    </button>
    <button pButton label="Start Run" icon="symbol-arrow-forward" [disabled]="simulationNameAvailable" iconPos="right"
      (click)="startRun(model)">
    </button>
  </div>
</div>